export default (state = {}, action) => {
  switch (action.type) {
    // case 'EHR_GET':
    //   const {
    //     content,
    //     totalPages,
    //     totalElements,
    //     last,
    //     size,
    //     sort,
    //     first,
    //     numberOfElements
    //   } = action.data;
    //   return {
    //     ...state,
    //     search: {
    //       result: copyArray(content),
    //       totalPages,
    //       totalElements,
    //       last,
    //       size,
    //       sort,
    //       first,
    //       numberOfElements
    //     }
    //   };
    case 'PHYPTMESSAGES_GET':
      return {
        ...state,
        allPhyPtMessages: { result: action.data }
      };
    case 'PHYPTMESSAGES_GET_DATE':
      return {
        ...state,
        allPhyPtMessagesofDate: { result: action.data }
      };
    case 'PATPTMESSAGES_GET':
      return {
        ...state,
        allPatPtMessages: { result: copyArray(action.data) }
      };
    case 'PAT_FOR_PTMESSAGES_GET':
      return {
        ...state,
        allPatforPtMessages: { result: copyArray(action.data.content) }
      };
    case 'REFRESH_COUNT':
      return {
        ...state,
        refreshTopBar: action.data
      };
    default:
      return state;
  }
};

const copyArray = items => {
  return items.map(item => {
    return Object.assign({}, item);
  });
};
